import React from 'react';

export type ChatymeLoadingVariant = 'app' | 'chat' | 'content';

interface ChatymeLoadingProps {
  variant?: ChatymeLoadingVariant;
}

const ChatymeLoading: React.FC<ChatymeLoadingProps> = ({ variant = 'app' }) => {
  if (variant === 'chat') {
    return (
      <div className="chatyme-chat-loading-wrapper">
        <div className="chatyme-chat-loading-screen" role="status" aria-label="Loading" />
      </div>
    );
  }

  if (variant === 'content') {
    return (
      <div
        className="chatyme-loading-container chatyme-loading-content"
        role="status"
        aria-label="Loading"
      >
        <div className="chatyme-loading-spinner" />
      </div>
    );
  }

  return (
    <div className="chatyme-loading-container" role="status" aria-label="Loading">
      <div className="chatyme-loading-spinner" />
    </div>
  );
};

export default ChatymeLoading;
